import Card from '../card/Card'
import imgcurriculo from '../../assets/fotojr2.jpg'
import './Curriculo.css'

function Curriculo(){
    return(
        <div className='curr-main'>
            <img className='curr-img' src={imgcurriculo} />    
            <Card/>       
        </div>
    )
}
export default Curriculo